import React, { Component } from 'react'
import { Trans } from '@lingui/react'
import { I18n } from '@lingui/core'

import { LayoutColumn } from 'client/shared/blocks/layout-column/layout-column'
import Spacer from 'client/shared/blocks/spacer'
import { CurrentUserState } from 'client/shared/types/current-user'

import { Heading } from 'client/shared/blocks/heading/heading'
import {
  BookshelfTab,
  BookshelfTopic,
} from 'client/bookmate/pages/shelves-page'

import { TopicTab } from './topic-tab'
import { UserTopicTab } from './user-topic-tab'

import './shelves-nav.styl'
import { QueryParams } from 'shared/tools/url-helper'

type Props = {
  currentUser: CurrentUserState
  topics: BookshelfTopic[]
  tabs?: BookshelfTab
  pathname: string
  i18n: I18n
  query?: QueryParams
}

export class ShelvesNav extends Component<Props> {
  render(): JSX.Element {
    const {
      topics,
      tabs,
      i18n,
      currentUser: { auth },
      pathname,
      query,
    } = this.props

    return (
      <LayoutColumn size={4}>
        <Heading rank={3}>
          <Trans id="search.by_topic" />
        </Heading>
        <Spacer size={64} />
        <UserTopicTab
          path="all"
          title={i18n._('auth.all')}
          pathname={pathname}
          query={query}
        />
        {topics?.map(topic => (
          <TopicTab topic={topic} pathname={pathname} query={query} />
        ))}
        {tabs?.friends && auth && (
          <UserTopicTab
            path="friends"
            title={i18n._('feed.friends_feed')}
            pathname={pathname}
            query={query}
          />
        )}
        {tabs?.following && auth && (
          <UserTopicTab
            path="following"
            title={i18n._('profile.own_shelves')}
            pathname={pathname}
            query={query}
          />
        )}
      </LayoutColumn>
    )
  }
}
